export default "__VITE_ASSET__C2sbe1fH__"